import ActivityWithEab from './ActivityWithEab';

export default ActivityWithEab;
